import script from "./VoucherTplList.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherTplList.vue?vue&type=script&setup=true&lang=js"

import "./VoucherTplList.vue?vue&type=style&index=0&id=47da0e78&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47da0e78"]])

export default __exports__